/**
 * Cookie consent strings. Placeholder wording pending counsel review: keep
 * every user-visible string here so the final copy is a one-file change.
 */

export const PRIVACY_COOKIES_HREF = '/privacy#cookies-and-similar-technologies';

export const PREFERENCES_COPY = {
  title: 'Privacy choices',
  lede: 'Choose which cookies Belhop may use. Your choice is saved in this browser and you can change it at any time.',
  close: 'Close',
  gpcHeading: 'Global Privacy Control detected — honoured.',
  gpcBody:
    'Your browser asked us not to sell or share your data, so analytics is off. You can still turn it on below if you choose to.',
  necessaryLabel: 'Strictly necessary',
  necessaryStatus: 'Always on',
  necessaryDescription:
    'Keeps you signed in, remembers your cart and stores this choice. The site cannot work without them.',
  detailsSummary: "What's stored",
  necessaryStored: 'Sign-in tokens, cart contents, your cookie choice, and session state.',
  analyticsLabel: 'Analytics',
  analyticsDescription:
    'Google Analytics shows us how Belhop is used so we can improve it. Advertising features are always off.',
  analyticsStored: '_ga and _ga_GQFN071VGM, set by Google Analytics.',
  rejectAll: 'Reject all',
  acceptAll: 'Accept all',
  saveChoices: 'Save choices',
  footnotePolicy: 'Read the Privacy Policy (Sections 13–15)',
  footnoteReopen:
    'You can reopen this from "Cookie settings" or "Do Not Sell or Share My Personal Information" in the footer.',
} as const;

export const FOOTER_PRIVACY_LABELS = {
  doNotSell: 'Do Not Sell or Share My Personal Information',
  cookieSettings: 'Cookie settings',
} as const;

export const BANNER_COPY = {
  regionLabel: 'Cookie consent',
  question: 'Can we use Google Analytics cookies to see how Belhop is used?',
  policyLink: 'Privacy Policy',
  reject: 'Reject',
  accept: 'Accept',
  manage: 'Manage',
} as const;
